import { useState } from "react"
import NotesIcon from "@assets/icons/notes"
import { Button } from "@components/Button"
import usePatient from "@hooks/usePatient"
import { useSelector } from "react-redux"

const AddComment = ({ patientId, refreshPatientData }) => {
  const [comment, setComment] = useState("")
  const { handleAddComment } = usePatient()
  const { isAddCommentLoading } = useSelector((state) => state.patient)

  const updateCommentInput = (event) => {
    setComment(event.currentTarget.value)
  }

  const onAddCommentSubmit = () => {
    if (comment !== "") {
      handleAddComment(
        {
          patientId,
          comment,
        },
        onAddCommentSuccess
      )
    }
  }

  const onAddCommentSuccess = () => {
    refreshPatientData()
    setComment("")
  }

  return (
    <div
      className="py-10 px-8 md:p-0 bg-[--primary-blue-light]
      md:bg-[transparent] flex flex-col gap-4 rounded-2xl"
    >
      <div className="md:py-8 md:px-8 rounded-2xl bg-[--primary-blue-light] flex flex-col gap-6">
        <div className="gap-2 flex items-center">
          <NotesIcon stroke="var(--primary-blue)" />
          <div className="text-xs text-[--text-light-gray] font-bold tracking-widest">
            ADD NEW COMMENT
          </div>
        </div>

        <div className="flex flex-col md:flex-row gap-16">
          <textarea
            onChange={updateCommentInput}
            className="p-6 rounded-2xl bg-[--pure-white] h-[9rem] grow md:border border-[--primary-blue] text-base"
            placeholder="type your comment here"
            value={comment}
          />
        </div>

        <Button
          variant="primary"
          className="w-[7.87rem] ml-auto"
          loading={isAddCommentLoading}
          type="button"
          onClick={onAddCommentSubmit}
          disabled={isAddCommentLoading || comment === ""}
        >
          Submit
        </Button>
      </div>
    </div>
  )
}

export default AddComment
